import { Observable, Subject, map } from 'rxjs';
import { MonoTypeOperatorFunction } from 'rxjs';
import { delay as delayOperator, retryWhen, scan } from 'rxjs/operators';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { UtilsMisc } from './utils.misc';

export class UtilsRxjs {

    public static completeSubscription(subscription: Subject<any>): void {
        if (UtilsMisc.isNullOrUndefined(subscription) === false) {
            //subscription.next();
            subscription.complete();
        }
    }

    public static createEmptySubscription(): Subject<void> {
        return (new Subject<void>());
    }

    public static createSubscription(timeToDebounce: number, callback: (value: any) => any): Subject<any> {
        const result: Subject<any> = new Subject<any>();
        result
            .pipe(debounceTime(timeToDebounce))
            .pipe(distinctUntilChanged())
            .subscribe(value => {
                callback(value);
            });

        return result;
    }

}

export function throwIf<T>(
    conditionFn: (value: T, index: number) => boolean,
    errorFn: (value: T, index: number) => any
) {
    return (input: Observable<T>) =>
        input.pipe(
            map((value: T, index: number) => {
                if (conditionFn(value, index)) {
                    throw errorFn(value, index);
                }

                return value;
            })
        );
}

export function retryWithDelay<T>(
    delay: number,
    count = 1
): MonoTypeOperatorFunction<T> {
    return (input) =>
        input.pipe(
            retryWhen(errors =>
                errors.pipe(
                    scan((acc, error) => ({ count: acc.count + 1, error }), {
                        count: 0,
                        error: undefined as any,
                    }),
                    throwIf(
                        (current) => current.count > count,
                        (current) => current.error
                    ),
                    delayOperator(delay)
                )
            )
        );
}
